import "./index.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "App";
import { withAuthenticationTimeout } from "lib/authentication";
import { keycloak, keycloakInitOptions } from "lib/keycloak";

function initKeycloak() {
  const rootEl = document.getElementById("root");
  if (!rootEl) throw new Error("Root element not found");

  const root = createRoot(rootEl);
  withAuthenticationTimeout(keycloak.init(keycloakInitOptions))
    .then(function () {
      root.render(
        <StrictMode>
          <App keycloak={keycloak} />
        </StrictMode>,
      );
    })
    .catch(function (err: unknown) {
      console.error(err);
      root.render(
        <StrictMode>
          <App keycloak={keycloak} authenticationError />
        </StrictMode>,
      );
    });
}

initKeycloak();
